<template>
  <v-app v-if="active">
    <v-container>
      <v-row justify="center" class="mt-8 mb-8">
        <v-img max-width="240" :src="iconUrl"></v-img>
      </v-row>
      <v-row align="center" justify="center" class="mt-4">
        <v-col cols="auto">
          <span class="">専用 URL よりアクセスしてください</span>
        </v-col>
      </v-row>
      <v-row align="center" justify="center" class="mt-4">
        <v-col cols="auto">
          <v-btn x-large text class="mt-12" @click="moveOfficialSite">
            <span class="text-decoration-underline">公式サイトはこちら</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import liff from "@line/liff";
const URL_OFFICAL_SITE = "https://site.nobunaga.life/";
const IMAGE_LOGO = require("@/assets/logo_nobunaga.png");
export default {
  data: () => ({
    active: false,
    iconUrl: IMAGE_LOGO,
  }),
  async created() {
    await liff.ready; // LIFF 初期化待機

    // ルートアクセス以外は何も表示しない
    const path = this.$route.path;
    console.log(`path=${path}`);
    if (path !== "/") {
      return;
    }

    // 画面表示
    this.active = true;
    this.$store.state.title = "ノブナガ";
  },
  methods: {
    moveOfficialSite() {
      liff.openWindow({ url: URL_OFFICAL_SITE });
      // liff.openWindow({ url: URL_OFFICAL_SITE, external: true });
    },
  },
};
</script>
